<template>

<core-filter-advanced-group title="Version" :count="count">

	<core-filter-input-text placeholder="Search edition names..." :filter="value('version/name')" class="text" :inset="true" />

	<core-filter-input-range text="Edition worth" min="0" max="500" maxText="Any" :filter="value('version/worth')" step="5" pips="50" decimals="0" density="10" :tooltip="true" />

	<core-filter-input-range text="Box width" subtext="(mm)" min="0" max="500" maxText="Any" :filter="value('version/size/width')" step="10" pips="100" decimals="0" density="10" :tooltip="true" />

	<core-filter-input-range text="Box length" subtext="(mm)" min="0" max="500" maxText="Any" :filter="value('version/size/length')" step="10" pips="100" decimals="0" density="10" :tooltip="true" />

	<core-filter-input-range text="Box depth" subtext="(mm)" min="0" max="500" maxText="Any" :filter="value('version/size/depth')" step="10" pips="100" decimals="0" density="10" :tooltip="true" />

	<core-filter-input-range text="Box weight" subtext="(g)" min="0" max="5000" maxText="Any" :filter="value('version/size/weight')" step="100" pips="1000" decimals="0" density="10" :tooltip="true" />

	<core-filter-input-range text="Box footprint" subtext="(width × length × depth, mm³)" min="0" max="50000000" maxText="Any" :filter="value('version/size/footprint')" step="500000" pips="10000000" decimals="0" density="10" :tooltip="true" />

</core-filter-advanced-group>

</template>

<script>

import Group from 'core/mixin/filter/Group.js'

export default {

	mixins: [Group],

	data: function() {

		return {
			fields: ['version.name', 'version.worth', 'version.size.width', 'version.size.length', 'version.size.depth', 'version.size.weight', 'version.size.footprint']
		}
	}

}

</script>

<style scoped>

.text {
	padding: 0px!important;
}

</style>
